import { create } from 'zustand'
import { getSupabase } from '../api/supabase'
import { loadSavedAccounts, removeSavedAccount, upsertSavedAccount } from './saved-accounts'
import type { SavedAccount } from '../types/profile'

// 2026-05-28 owner 决策推翻原"refresh_token 一键直登"方案:
// 改为明文存账号 + 密码,点击 saved row 由 UI 层填充表单(不在 store 层自动登录)。
// 因此 setActive 不再调用 supabase.refreshSession;仅返回选中账号信息供 UI 填表单。

type AuthState = {
  accounts: SavedAccount[]
  activeUserId: string | null
  hydrated: boolean
}

type AuthActions = {
  hydrate: () => void
  // setActive 仅设置 active 标识 + 返回该账号信息;不再触发 refreshSession
  // 调用方(UI)负责把 username/password 填入登录表单
  setActive: (userId: string) => SavedAccount | undefined
  removeAccount: (userId: string) => void
  recordLogin: (account: SavedAccount) => void
  signOut: () => Promise<void>
}

export const useAuthStore = create<AuthState & AuthActions>((set, get) => ({
  accounts: [],
  activeUserId: null,
  hydrated: false,

  hydrate: () => {
    if (get().hydrated) return
    const accounts = loadSavedAccounts()
    set({ accounts, hydrated: true })
  },

  setActive: (userId) => {
    const acc = get().accounts.find((a) => a.user_id === userId)
    if (!acc) return undefined
    set({ activeUserId: userId })
    return acc
  },

  removeAccount: (userId) => {
    const next = removeSavedAccount(userId)
    set((s) => ({
      accounts: next,
      activeUserId: s.activeUserId === userId ? null : s.activeUserId,
    }))
  },

  recordLogin: (account) => {
    const next = upsertSavedAccount(account)
    set({ accounts: next, activeUserId: account.user_id })
  },

  signOut: async () => {
    // saved-account 不再依赖 refresh_token,但保持 scope=local 一致(避免 server 多 RTT)。
    // 用户的 saved row 在退出后依然可见;点击会从 localStorage 取账号密码填表单。
    await getSupabase().auth.signOut({ scope: 'local' })
    set({ activeUserId: null })
  },
}))
